import { useCallback, useEffect, useState } from 'react';

import {
  isAdpReferralSubmitted,
  setAdpReferralSubmitted
} from '#client/pages/ProductLanding/utils/adpReferralStorage';

export function useAdpReferralCtaState({ isAdpProduct, businessEntityUuid }) {
  const [adpReferralSubmitted, setAdpReferralSubmittedState] = useState(
    () => (isAdpProduct ? isAdpReferralSubmitted(businessEntityUuid) : false)
  );

  useEffect(() => {
    if (!isAdpProduct) {
      setAdpReferralSubmittedState(false);
      return;
    }

    setAdpReferralSubmittedState(isAdpReferralSubmitted(businessEntityUuid));
  }, [businessEntityUuid, isAdpProduct]);

  const markAdpReferralSubmitted = useCallback(() => {
    if (!isAdpProduct || !businessEntityUuid) {
      return;
    }

    setAdpReferralSubmitted(businessEntityUuid);
    setAdpReferralSubmittedState(true);
  }, [businessEntityUuid, isAdpProduct]);

  return {
    adpReferralSubmitted,
    markAdpReferralSubmitted
  };
}
